class DetailsModal extends HTMLElement {
  constructor() {
    super();
    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');

    this.detailsContainer.addEventListener('keyup', (event) => event.code.toUpperCase() === 'ESCAPE' && this.close());
    this.summaryToggle.addEventListener('click', this.onSummaryClick.bind(this));
    this.querySelector('button[type="button"]').addEventListener('click', this.close.bind(this));

    this.summaryToggle.setAttribute('role', 'button');
  }

  isOpen() {
    return this.detailsContainer.hasAttribute('open');
  }

  onSummaryClick(event) {
    event.preventDefault();
    event.target.closest('details').hasAttribute('open') ? this.close() : this.open(event);
  }

  onBodyClick(event) {
    if (!this.contains(event.target) || event.target.classList.contains('modal-overlay')) this.close(false);
  }

  open(event) {
    this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
    event.target.closest('details').setAttribute('open', true);
    document.body.addEventListener('click', this.onBodyClickEvent);
    document.body.classList.add('overflow-hidden');

    document.querySelector(".header").classList.add("header-selector");
    document.querySelector("sticky-header").classList.add("sticky-header-bg");
    document.querySelector(".header").style.borderColor="transparent";
    document.querySelector("sticky-header").style.borderWidth="2px";
    
    let header = document.querySelector(".section-header");
    header.classList.add("custom-search-header");

    trapFocus(
      this.detailsContainer.querySelector('[tabindex="-1"]'),
      this.detailsContainer.querySelector('input:not([type="hidden"])')
    );
  }

  close(focusToggle = true) {
    removeTrapFocus(focusToggle ? this.summaryToggle : null);
    this.detailsContainer.removeAttribute('open');
    document.body.removeEventListener('click', this.onBodyClickEvent);
    document.body.classList.remove('overflow-hidden');

    document.querySelector(".header").classList.remove("header-selector");
    document.querySelector("sticky-header").classList.remove("sticky-header-bg");
    if (document.querySelector(".header-wrapper").classList.contains('black-header')) {
      document.querySelector(".header").style.borderColor="black";
    } else if (document.querySelector(".header-wrapper").classList.contains('white-header')){
      document.querySelector(".header").style.borderColor="white";
    }
    document.querySelector("sticky-header").style.borderWidth="1px";
    let header = document.querySelector(".section-header");
    header.classList.remove("custom-search-header");

    let pxToScroll;
    if(screen.width > 1200 && 1650 > screen.width){
      pxToScroll = 80;
    }else{
      pxToScroll = 200;
    }
    window.onscroll = function() {
    if (document.body.scrollTop > pxToScroll || document.documentElement.scrollTop > pxToScroll) {
        document.querySelector(".header").classList.add("header-selector");
        document.querySelector("sticky-header").classList.add("sticky-header-bg");
        
      } else {
        document.querySelector(".header").classList.remove("header-selector");
        document.querySelector("sticky-header").classList.remove("sticky-header-bg");
        
      }
    };
    
  }
}

customElements.define('details-modal', DetailsModal);
